import { settings } from '@dabble/app';
import './locales';
import './track-changes-formats';
import { trackChangesModule } from './track-changes-module';

settings.configure('dabble', {
  editorModules: {
    trackChanges: trackChangesModule,
  },
  editorTypes: {
    trackChanges: {
      formats: ['ins', 'd3l', 'formatChange'],
    },
  },
});
